import React, {useEffect, useRef, useState} from 'react'
import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    RequiredRule,
    EmailRule, AsyncRule
} from 'devextreme-react/form';
import {useHistory} from "react-router-dom";
import {inject, observer} from "mobx-react";
import {auth, db} from '../../../../firebase/Firebase';
import {useSnackbar} from 'notistack';
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {NotiStackInfo} from "../../../../palette/NotiStackInfo";
import Alerts from "../../../../palette/Alerts";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {useMountedState} from "../../../../utils/UnMounted";
import {asyncValidation} from "../../../../utils/Validations";

const passwordOptions = {
    mode: 'password',
    showClearButton: true
};

const account = {
    email: '',
    password: '',
};

const SET_INITIAL_DATA = "SET_INITIAL_DATA";

function Login(props) {

    const {DataStore, SessionStore} = props
    const {isTimedOut} = SessionStore

    const [submitButton, setSubmitButton] = useState({...buttonSuccess, icon: 'fas fa-sign-in-alt'})
    const [space, setSpace] = useState(false);
    const [emailVerified, setEmailVerified] = useState(true);

    const isMounted = useMountedState()

    useEffect(() => {
        if(isMounted()){
            const {instance} = dxForm.current
            instance.resetValues()
        }
    }, [isMounted])

    let history = useHistory();
    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);

    const spaceRender = () => {
        return (
            <div>
                {space &&
                <span style={{fontSize: 12, color: 'red'}}>El correo electronico contiene espacios en blanco</span>}
            </div>
        )
    }

    const onValueChanged = () => {
        const str = account.email;
        if (str.indexOf(' ') >= 0) {
            setSpace(true)
        } else {
            setSpace(false)
        }
    }

    const onAccountSubmit = async (e) => {
        e.preventDefault()
        setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true, text: 'Iniciando..'})

        await auth.signInWithEmailAndPassword(account.email.trim(), account.password.trim())
            .then(() => {
                auth.onAuthStateChanged(async user => {
                    if (user) {
                        if (user.emailVerified) {
                            let dataUser = null;
                            await db.collection('Users').doc(user.uid).get()
                                .then((doc) => {
                                    dataUser = doc.data()
                                })
                            if (dataUser) {
                                const dashboard = dataUser.permits[0].dashboard
                                DataStore.getCompanyData(user.displayName, dataUser.idCompany, dataUser.role, dataUser.companyMail)
                                SessionStore.onHandleAuthenticateUser(SET_INITIAL_DATA, true)


                                if (dataUser.finished && dashboard) {
                                    history.push('/control-panel/dashboard')
                                    DataStore.getTabs('Dashboard')
                                }

                                if (dataUser.finished && !dashboard) {
                                    history.push('/control-panel/welcome')
                                    DataStore.getTabs('')
                                }

                                if (!dataUser.finished) {
                                    history.push('/control-panel/my-company')
                                    DataStore.getTabs('Datos de mi empresa')
                                }

                                //dataUser.finished ? history.push('/control-panel/welcome') : history.push('/control-panel/my-company')
                                setSubmitButton({
                                    ...submitButton,
                                    icon: 'fas fa-sign-in-alt',
                                    disabled: false,
                                    text: 'Iniciar'
                                })
                            }
                        } else {
                            setEmailVerified(false)
                            setSubmitButton({
                                ...submitButton,
                                icon: 'fas fa-sign-in-alt',
                                disabled: false,
                                text: 'Iniciar'
                            })
                        }
                    } else {
                        history.push('/');
                    }
                })
            }).catch(() => {
                NotiStackInfo('Usuario o Contraseña incorrecta!', 'error', enqueueSnackbar)
                setSubmitButton({...submitButton, icon: 'fas fa-sign-in-alt', disabled: false, text: 'Iniciar'})
            })
    }

    return (
        <>
            <form action="" onSubmit={onAccountSubmit}>
                <Form
                    ref={dxForm}
                    formData={account}
                    readOnly={false}
                    showColonAfterLabel={true}
                    validationGroup="login-data"
                >
                    <GroupItem caption="Iniciar Sesión" colCount={1}>
                        <SimpleItem dataField="email" label={{text: 'Correo electrónico', location: 'top'}}
                                    editorOptions={{
                                        onValueChanged: onValueChanged,
                                        showClearButton: true,
                                        maxLength: 70
                                    }}>
                            <EmailRule message="Correo electrónico inválido"/>
                            <AsyncRule
                                message="Correo electrónico inválido"
                                validationCallback={asyncValidation} />
                            <RequiredRule message="Ingrese el correo electrónico de usuario"/>
                        </SimpleItem>
                        <SimpleItem dataField="password" label={{text: 'Contraseña', location: 'top'}}
                                    editorOptions={passwordOptions}>
                            <RequiredRule message="Ingrese una contraseña"/>
                        </SimpleItem>
                        <SimpleItem render={spaceRender}/>
                    </GroupItem>
                    <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                </Form>
            </form>
            <VerticalSpace space={10}/>
            {!emailVerified &&
            <Alerts severity='error' body='Su correo electrónico aun no ha sido verificado, por favor verifique su correo para continuar.
            Si el correo electrónico no aparece, busque en la carpeta spam y confirme en el link.'/>
            }
            {isTimedOut &&
            <Alerts severity='info' body='La sesión ha caducado, pulse iniciar para continuar.'/>
            }
        </>
    )
}


export default inject('DataStore', 'SessionStore')(observer(Login));